import { render, staticRenderFns } from "./dictionary_page.vue?vue&type=template&id=767cffa8&scoped=true"
import script from "./dictionary_page.vue?vue&type=script&lang=js"
export * from "./dictionary_page.vue?vue&type=script&lang=js"
import style0 from "./dictionary_page.vue?vue&type=style&index=0&id=767cffa8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767cffa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('767cffa8')) {
      api.createRecord('767cffa8', component.options)
    } else {
      api.reload('767cffa8', component.options)
    }
    module.hot.accept("./dictionary_page.vue?vue&type=template&id=767cffa8&scoped=true", function () {
      api.rerender('767cffa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/dictionary_page.vue"
export default component.exports